import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
  errors: null,
  isLoading: false,
  isSuccess: false,
  revenueData: null,
  lastUpdated: null
};

const revenueDetailsSlice = createSlice({
  name: "revenueDetails",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action) => {
      state.isSuccess = action.payload;
    },
    setRevenueData: (state, action) => {
      state.revenueData = action.payload;
    },
    setLastUpdated: (state, action) => {
      state.lastUpdated = action.payload;
    },
    resetRevenueDetails: (state) => {
      state.revenueData = null;
      state.errors = null;
      state.isSuccess = false;
      state.lastUpdated = null;
    }
  }
});

export const {
  setErrors,
  setLoading,
  setSuccess,
  setRevenueData,
  setLastUpdated,
  resetRevenueDetails
} = revenueDetailsSlice.actions;

// Get Revenue Details with Filters
export const getRevenueDetails = (filters = {}) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setErrors(null));
  
  try {
    const params = new URLSearchParams();
    
    if (filters.timePeriod) params.append('timePeriod', filters.timePeriod);
    if (filters.location) params.append('location', filters.location);
    if (filters.serviceGroup) params.append('serviceGroup', filters.serviceGroup);
    if (filters.category) params.append('category', filters.category);
    if (filters.subcategory) params.append('subcategory', filters.subcategory);
    
    const URL = `/serviceProvider/revenue/details?${params.toString()}`;
    const response = await axiosInstance.get(URL);
    const { status, message, data } = response?.data || {};

    if (status === "success") {
      dispatch(setRevenueData(data));
      dispatch(setLastUpdated(new Date().toISOString()));
      dispatch(setSuccess(true));
    } else {
      dispatch(setErrors({ message: message || "Failed to fetch revenue details" }));
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || error.message || "Something went wrong while loading revenue details";
    dispatch(setErrors({ message: errorMsg }));
  } finally {
    dispatch(setLoading(false));
  }
};

export default revenueDetailsSlice.reducer;
